import { render, staticRenderFns } from "./StoreGoodsHome.vue?vue&type=template&id=65a6fae4"
import script from "./StoreGoodsHome.vue?vue&type=script&lang=js"
export * from "./StoreGoodsHome.vue?vue&type=script&lang=js"
import style0 from "./StoreGoodsHome.vue?vue&type=style&index=0&id=65a6fae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports